import React, { createContext, useContext, useState } from 'react';
import SimpleSnackbar from './snackbar';
import PropTypes from 'prop-types';
import './snackBarProvider.scss';

const SnackbarContext = createContext();

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};

const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    message: '',
    severity: '',
    open: false,
    alertClassName: '',
  });

  const snackbarOpen = (message, severity, timeout = 4000, alertClassName = '') => {
    setSnackbar({ message, severity, open: true, alertClassName });
    setTimeout(() => setSnackbar((prev) => ({ ...prev, open: false })), timeout);
  };

  return (
    <SnackbarContext.Provider
      value={React.useMemo(() => ({ snackbarOpen }), [])}
    >
      {children}
      <SimpleSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        alertCss={`snackbar-provider ${snackbar.severity} ${snackbar.alertClassName || ''}`.trim()}
      />
    </SnackbarContext.Provider>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default SnackbarProvider;
